export default class ListaDeactivateIds {
    constructor(listaIds) {
        this.idsToDeactivate = listaIds 
    }
    static create(listaIds) {
        return new ListaDeactivateIds(listaIds)
    }
}